export const RUTA_TICKETS_ASIGNADOS = 'TicketsAsignados'
const RUTAS_PERMITIDAS = [RUTA_TICKETS_ASIGNADOS, 'ticketarea', 'ticketauxi']
const ESTADO_INICIAL = { iderp: null, restringido: false, pendientes: 0 }
/** Nunca se restringe el sistema por tickets de alumno o teacher. 31 = mantenimiento. */
const IDERPS_EXENTOS_BLOQUEO_TICKETS = [966, 31]

export function estaExentoBloqueoTickets(iderp) {
  return IDERPS_EXENTOS_BLOQUEO_TICKETS.includes(Number(iderp))
}

let estadoActual = Object.assign({}, ESTADO_INICIAL)

export function getEstadoBloqueoTickets() {
  return Object.assign({}, estadoActual)
}

export function setEstadoBloqueoTickets(parcial) {
  estadoActual = Object.assign({}, estadoActual, parcial || {})
  return getEstadoBloqueoTickets()
}

export function limpiarEstadoBloqueoTickets() {
  estadoActual = Object.assign({}, ESTADO_INICIAL)
  return getEstadoBloqueoTickets()
}

export function estaRestringidoTickets(iderp) {
  if (estaExentoBloqueoTickets(iderp)) return false
  if (!estadoActual.restringido || estadoActual.iderp == null) return false
  return Number(estadoActual.iderp) === Number(iderp)
}

export function rutaPermitidaEnBloqueoTickets(nombreRuta) {
  return RUTAS_PERMITIDAS.includes(nombreRuta)
}

export function menuSoloTickets() {
  return [
    {
      title: 'Tickets asignados',
      action: 'mdi-ticket-account',
      active: true,
      items: [{ title: 'Tickets asignados', path: RUTA_TICKETS_ASIGNADOS, active: 0 }],
    },
  ]
}
